/**
 * LP02 Timeline Planner (MC)
 * Custom Element que sincroniza el slider de "días hasta el evento"
 * con el contador de texto y el mensaje de estado (badge), comparando
 * el valor elegido contra dos umbrales configurables desde el schema.
 * Vanilla JS, sin dependencias externas.
 */

(function () {
  if (customElements.get('lp02-timeline-planner-mc-app')) return;

  class Lp02TimelinePlannerMC extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('[data-timeline-slider]');
      this.daysValue = this.querySelector('[data-timeline-days-value]');
      this.badge = this.querySelector('[data-timeline-badge]');

      if (!this.slider || !this.daysValue || !this.badge) return;

      this.thresholdTight = this.getNumber('[data-timeline-threshold-tight]', 14);
      this.thresholdUrgent = this.getNumber('[data-timeline-threshold-urgent]', 7);

      this.statusGoodText = this.getText('[data-timeline-status-good]');
      this.statusTightText = this.getText('[data-timeline-status-tight]');
      this.statusUrgentText = this.getText('[data-timeline-status-urgent]');

      this._onInput = this.onInput.bind(this);
      this.slider.addEventListener('input', this._onInput);

      this.update(this.slider.value);
    }

    disconnectedCallback() {
      if (this.slider) this.slider.removeEventListener('input', this._onInput);
    }

    getNumber(selector, fallback) {
      var el = this.querySelector(selector);
      var value = el ? parseFloat(el.textContent) : NaN;
      return isNaN(value) ? fallback : value;
    }

    getText(selector) {
      var el = this.querySelector(selector);
      return el ? el.textContent.trim() : '';
    }

    onInput(event) {
      this.update(event.target.value);
    }

    update(value) {
      var days = Number(value);

      this.daysValue.textContent = days;
      this.updateSliderFill(days);
      this.updateBadge(days);
    }

    updateSliderFill(days) {
      var min = Number(this.slider.min) || 0;
      var max = Number(this.slider.max) || 100;
      var percent = ((days - min) / (max - min)) * 100;
      var fillColor = getComputedStyle(this).getPropertyValue('--lp02-timeline-color-slider-fill').trim() || '#3fb3a8';
      var trackColor = getComputedStyle(this).getPropertyValue('--lp02-timeline-color-slider-track').trim() || '#16232b';
      this.slider.style.background =
        'linear-gradient(to right, ' +
        fillColor + ' 0%, ' +
        fillColor + ' ' + percent + '%, ' +
        trackColor + ' ' + percent + '%, ' +
        trackColor + ' 100%)';
    }

    updateBadge(days) {
      var text = this.statusGoodText;
      if (days < this.thresholdUrgent) {
        text = this.statusUrgentText;
      } else if (days < this.thresholdTight) {
        text = this.statusTightText;
      }
      this.badge.textContent = text;
    }
  }

  customElements.define('lp02-timeline-planner-mc-app', Lp02TimelinePlannerMC);
})();
